//新建活动或者浮标以及弹窗时，判断skinfig是不是空
export function isSkinConfig (activityid,skinconfig) {
  if(activityid == 0 && skinconfig == ""){ //证明是新建皮肤的时候并且skinconfig为空，这时不不能保存
	return false  	
  }else{
  	return true
  }
}


// WEBPACK FOOTER //
// ./src/api/isSkin.js